import { createSelector } from "reselect";

const hintsLeft = (state) => state.designChapter.currentView.hintsLeft;

const totalHints = (state) => state.designChapter.currentView.totalHints;

export const getHintsData = createSelector(
  [hintsLeft, totalHints],
  (hintsLeft, totalHints) => {
    return { hintsLeft, totalHints };
  }
);
